// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3C8bt","header":"ReportDetails_header__3-qxN","title":"ReportDetails_title__38clg","left":"ReportDetails_left__QVFMn"};